"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.autoListByType = autoListByType;
exports.bindStoreList = bindStoreList;
exports.cardAddArticle = cardAddArticle;
exports.cardChangeState = cardChangeState;
exports.cardDelArticle = cardDelArticle;
exports.cardListArticle = cardListArticle;
exports.changeCakeState = changeCakeState;
exports.changeDentalState = changeDentalState;
exports.changeFilmState = changeFilmState;
exports.changeLypJdStatus = changeLypJdStatus;
exports.changeLypSmStatus = changeLypSmStatus;
exports.changeMealState = changeMealState;
exports.changeMerchantJdState = changeMerchantJdState;
exports.changeMerchantState = changeMerchantState;
exports.changeMerchantTgState = changeMerchantTgState;
exports.changeOfflineState = changeOfflineState;
exports.changeOpState = changeOpState;
exports.changeParkingState = changeParkingState;
exports.changeSjtState = changeSjtState;
exports.changeState = changeState;
exports.changeStationState = changeStationState;
exports.changeWaterState = changeWaterState;
exports.deleteBind = deleteBind;
exports.getAllMiniProgramList = getAllMiniProgramList;
exports.getCardInfo = getCardInfo;
exports.getChannelBind = getChannelBind;
exports.goodsBindChannel = goodsBindChannel;
exports.merchantStoreBind = merchantStoreBind;
exports.orderCardListArticle = orderCardListArticle;
exports.productList = productList;
exports.selectCard = selectCard;
exports.selectChannel = selectChannel;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 获取所有小程序列表
 */
function getAllMiniProgramList() {
  // return request({
  //     url: '/admin/companyapp/autoList',
  //     method: 'GET',
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get'
  });
}

/**
 * 获取详情
 */

function getCardInfo(id) {
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/fucard/info/${id}`,
    url: "/mapi/asset/web/fudou/fucard/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 列表
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/list',
    url: '/mapi/asset/web/fudou/channel/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 更新渠道
 */
function AddArticle() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/save',
    url: '/mapi/asset/web/fudou/channel/save',
    method: 'post',
    data: data
  });
}

/**
 * 修改状态
 */
function changeState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/status',
    url: '/mapi/asset/web/fudou/channel/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改状态-是否可线下支付
 */
function changeOpState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/offlinePayment',
    url: '/mapi/asset/web/fudou/channel/offlinePayment',
    method: 'post',
    params: data
  });
}

/**
 * 修改状态-是否电影
 */
function changeFilmState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/film/status',
    url: '/mapi/asset/web/fudou/channel/film/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改状态-是否点餐
 */
function changeMealState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/meal/status',
    url: '/mapi/asset/web/fudou/channel/meal/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改状态-开启蛋糕权限
 */
function changeCakeState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/cake/status',
    url: '/mapi/asset/web/fudou/channel/cake/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改状态-是否核销支付
 */
function changeOfflineState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/offline/status',
    url: '/mapi/asset/web/fudou/channel/offline/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改SJT状态
 */
function changeSjtState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/sjt/status',
    url: '/mapi/asset/web/fudou/channel/sjt/status',
    method: 'post',
    params: data
  });
}
/**
 * 修改SJT状态
 */
function changeDentalState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/dental/status',
    url: '/mapi/asset/web/fudou/channel/dental/status',
    method: 'post',
    params: data
  });
}
/**
 * 修改多商户状态
 */
function changeMerchantState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/merchant/status',
    url: '/mapi/asset/web/fudou/channel/merchant/status',
    method: 'post',
    params: data
  });
}
/**
 * 修改酒店状态
 */
function changeMerchantJdState(data) {
  return (0, _request.default)({
    url: '/admin/fudou/channel/merchantJd/status',
    method: 'post',
    params: data
  });
}
/**
 * 修改团购状态
 */
function changeMerchantTgState(data) {
  return (0, _request.default)({
    url: '/admin/fudou/channel/merchantTg/status',
    method: 'post',
    params: data
  });
}

/**
 * 来一票京东（来一票）状态
 */
function changeLypJdStatus(data) {
  return (0, _request.default)({
    url: '/admin/fudou/channel/lyp/jd/status',
    method: 'post',
    params: data
  });
}

/**
 * 山姆（来一票）状态
 */
function changeLypSmStatus(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/lyp/sm/status',
    url: '/mapi/asset/web/fudou/channel/lyp/sm/status',
    method: 'post',
    params: data
  });
}

/**
 * 绑定店铺
 */
function merchantStoreBind(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/merchant/bind',
    url: '/mapi/asset/web/fudou/channel/merchant/bind',
    method: 'post',
    data: data
  });
}

/**
 * 获取店铺列表
 */
function bindStoreList(params) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/merchant/bindStoreList',
    url: '/mapi/asset/web/fudou/channel/merchant/bindStoreList',
    method: 'post',
    data: params
  });
}

/**

 * 修改三江停车状态
 */
function changeParkingState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/parking/status',
    url: '/mapi/asset/web/fudou/channel/parking/status',
    method: 'post',
    params: data
  });
}
/**
 * 修改三江油状态
 */
function changeStationState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/station/status',
    url: '/mapi/asset/web/fudou/channel/station/status',
    method: 'post',
    params: data
  });
}

/**
 * 修改三江水状态
 */
function changeWaterState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/water/status',
    url: '/mapi/asset/web/fudou/channel/water/status',
    method: 'post',
    params: data
  });
}

/**
 * 删除
 */
function DelArticle(pram) {
  var data = {
    ids: pram.id
  };
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/channel/delete`,
    url: '/mapi/asset/web/fudou/channel/delete',
    method: 'DELETE',
    params: data
  });
}

/**
 * 渠道商品列表
 */
function productList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/channel/bind/list',
    url: '/mapi/asset/web/fudou/channel/bind/list',
    method: 'post',
    data: pram
  });
}

/**
 * 绑定产品
 */
function goodsBindChannel(data) {
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/channel/add/bind`,
    url: '/mapi/asset/web/fudou/channel/add/bind',
    method: 'post',
    data: data
  });
}

/**
 * 删除绑定商品
 */
function deleteBind(data) {
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/channel/bind/remove`,
    url: '/mapi/asset/web/fudou/channel/bind/remove',
    method: 'POST',
    data: data
  });
}

/**
 * 频道下拉选择
 */
function selectChannel(keyword) {
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/channel/select`,
    url: '/mapi/asset/web/fudou/channel/select',
    method: 'post',
    data: {
      keyword: keyword
    }
  }).then(function (res) {
    return res && res.length ? res.map(function (item) {
      var _ref = item || {},
        id = _ref.id,
        channel_name = _ref.channel_name;
      return _objectSpread(_objectSpread({}, item), {}, {
        channel_name: "".concat(channel_name, "\u3010").concat(id, "\u3011")
      });
    }) : [];
  });
}

/**
 * 获取绑定数据
 */
function getChannelBind(channelId) {
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/channel/get/bind/${channelId}`,
    url: "/mapi/asset/web/fudou/channel/get/bind/".concat(channelId),
    method: 'post',
    params: {
      channelId: channelId
    }
  });
}

// 卡片------------------------------------------------------------------
/**
 * 列表
 */
function cardListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/fucard/list',
    url: '/mapi/asset/web/fudou/fucard/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 列表
 */
function orderCardListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/fudou/fucard/orderCard/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 更新
 */
function cardAddArticle() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/fucard',
    url: '/mapi/asset/web/fudou/fucard',
    method: 'post',
    data: data
  });
}

/**
 * 修改状态
 */
function cardChangeState(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/fucard',
    url: '/mapi/asset/web/fudou/fucard',
    method: 'put',
    params: data
  });
}

/**
 * 删除
 */
function cardDelArticle(pram) {
  var data = {
    cardIds: pram.id
  };
  return (0, _requestMapi.default)({
    //url: `/admin/fudou/fucard`,
    url: '/mapi/asset/web/fudou/fucard',
    method: 'DELETE',
    params: data
  });
}

/**
 * 下拉选择
 */
function selectCard(keyword, isCombo) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/fucard/select',
    url: '/mapi/asset/web/fudou/fucard/select',
    method: 'get',
    params: JSON.stringify(isCombo) ? {
      keyword: keyword,
      isCombo: isCombo
    } : {
      keyword: keyword
    }
  }).then(function (res) {
    return res && res.length ? res.map(function (item) {
      var _ref2 = item || {},
        id = _ref2.id,
        card_name = _ref2.card_name;
      return _objectSpread(_objectSpread({}, item), {}, {
        card_name: "".concat(card_name, "\u3010").concat(id, "\u3011")
      });
    }) : [];
  });
}
function autoListByType(params) {
  // return request({
  //     url: '/admin/business/supplier/autoListByType',
  //     method: 'GET',
  //     params,
  // });

  return (0, _requestMapi.default)({
    url: "/mapi/user/supplier/autoListByType",
    method: 'GET',
    params: params
  });
}